import $http from '@/libs/axios'

export default class N8nInstagramAccountsApi {
  static async getN8nInstagramAccounts(params?: any) {
    return (await $http.get('n8n-instagram-accounts', { params })).data
  }

  static async getN8nInstagramAccount(id: number) {
    return (await $http.get(`n8n-instagram-accounts/${id}`)).data
  }

  static async createN8nInstagramAccount(data: any) {
    return (await $http.post('n8n-instagram-accounts', data)).data
  }

  static async updateN8nInstagramAccount(id: number, data: any) {
    return (await $http.put(`n8n-instagram-accounts/${id}`, data)).data
  }

  static async deleteN8nInstagramAccount(id: number) {
    return (await $http.delete(`n8n-instagram-accounts/${id}`)).data
  }

  static async getN8nInstagramAccountsHistory(params?: any) {
    return (await $http.get('n8n-instagram-posts-history', { params })).data
  }

  static async getN8nInstagramAccountHistory(id: number) {
    return (await $http.get(`n8n-instagram-posts-history/${id}`)).data
  }

  static async createN8nInstagramAccountHistory(data: any) {
    return (await $http.post('n8n-instagram-posts-history', data)).data
  }

  static async updateN8nInstagramAccountHistory(id: number, data: any) {
    return (await $http.put(`n8n-instagram-posts-history/${id}`, data)).data
  }

  static async deleteN8nInstagramAccountHistory(id: number) {
    return (await $http.delete(`n8n-instagram-posts-history/${id}`)).data
  }
}
